import React from 'react';
import constants from '../app/constants';

/**
 * @param props.imageClass
 * @param props.url
 * @param props.fileName
 * @param props.handleClick
 * @param props.alt
 * @param props.style
 */
const Image = props => {
    return props.fileName ? (
        <img
            className={props.imageClass}
            src={props.url + props.fileName + '.png'}
            srcSet={constants.imageSrcsetTemplate
                .replace('{url}', props.url)
                .replace('{url}', props.url)
                .replace('{filename}', props.fileName)
                .replace('{filename}', props.fileName)}
            onClick={props.handleClick ? props.handleClick : null}
            alt={props.alt}
            style={props.style}
        />
    ) : null;
};

export default Image;
